<template>
  <div>
    <section class="register-photo" style="background: rgb(255,255,255);">
        <div class="form-container">
            <form class="needs-validation" style="width=73%;">
                <h2 class="text-center">Kayıtlı Firma Girişi</h2>
                <div class="form-group">
                    <input class="form-control" v-model="form.email" type="text" style="width: 100%;" placeholder="E-Mail Adresiniz" name="email" required="">
                </div>
                <div class="form-group">
                    <input class="form-control" v-model="form.password" type="password" name="password" placeholder="Şifrenizi Girin" required="">
                </div>
                <div class="form-group">
                    <div class="form-check"><label class="form-check-label"><input class="form-check-input" type="checkbox">Beni Hatırla</label></div>
                </div>
                <div class="form-group" style="text-align:center; margin-top:-30px;">
                  <button :disabled="isLoading" @click="handleLogin" class="btn btn-primary btn-lg" type="submit" style="background: #60859b;font-size:14px;">Giriş Yap</button>
                </div>
                <a class="already" href="#">Şifrenizi mi unuttunuz?</a>
            </form>
        </div>
    </section>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  export default{
    name: 'Login',
    data(){
      return{
          form:{
            email:null,
            password:null,
          }
      }
    },
    computed:{
      ...mapState("auth", ["isLoading"])
    },
    methods:{
      ...mapActions("auth", ["login"]),
      handleLogin() {
        this.login(this.form)
      }
    },
  }
</script>
